export default __webpack_public_path__ + "static/media/dashboard_mobile.ecebec02.png";